import React, { ReactNode } from 'react';
import {
  SxProps, Card, CardContent, Typography, Box, CardActions, Button,
} from '@mui/material';
import { quickActionsShadow } from '../../../theme';

function CtaCard({
  title,
  subtitle,
  subtitleColor,
  background,
  color,
  image,
  imageWidth,
  imageHeight,
  buttonColor,
  buttonText,
  onClick,
  sx,
}: {
  title: string,
  subtitle: string | ReactNode,
  subtitleColor?: string,
  background?: string,
  color?: string,
  image?: string,
  imageWidth?: number,
  // When set, the image is sized by height (auto width) so a row of cards with
  // different-aspect images all show the artwork at the same height.
  imageHeight?: number,
  buttonColor?: string,
  buttonText: string,
  onClick?: () => void,
  sx?: SxProps,
}) {
  return (
    <Card
      elevation={0}
      sx={{
        width: 'auto',
        height: 256,
        flexShrink: 0,
        position: 'relative',
        background,
        color,
        boxShadow: quickActionsShadow,
        mr: 2,
        mb: 2,
        ...sx,
      }}
    >
      <CardContent
        sx={{ px: 4, pt: 5, pb: 5 }}
      >
        <Typography variant="sectionTitle">{title}</Typography>
        <Typography sx={{ mt: 1, color: subtitleColor ?? 'rgba(0, 0, 0, 0.6)' }} variant="body2">{subtitle}</Typography>
      </CardContent>
      <Box sx={{
        position: 'absolute',
        left: 0,
        bottom: 0,
        ...(imageHeight ? { height: imageHeight } : { width: imageWidth ?? 167 }),
      }}
      >
        <img
          style={imageHeight ? { height: '100%', width: 'auto', display: 'block' } : { width: '100%' }}
          src={image}
          alt=""
          onError={(e) => { (e.target as HTMLImageElement).style.display = 'none'; }}
        />
      </Box>
      <CardActions sx={{
        justifyContent: 'end', padding: 4, pt: 0, position: 'absolute', right: 0, bottom: 0,
      }}
      >
        <Button size="small" onClick={onClick} sx={{ color: buttonColor }}>{buttonText}</Button>
      </CardActions>
    </Card>
  );
}

export default CtaCard;
